import React, { useState } from "react";
import { Popover, Button, Tooltip } from "antd";
import DeleteIcon from "../../common/DeleteIcon";

const DeleteActionPopover = ({ icon: Icon, onDelete, onDeleteLinked }) => {
  const [visible, setVisible] = useState(false);

  const close = () => setVisible(false);

  const handleDelete = async () => {
    await onDelete?.();
    close();
  };

  const handleDeleteLinked = async () => {
    await onDeleteLinked?.();
    close();
  };

  const content = (
    <div style={{ width: 260 }}>
      <p style={{ marginBottom: 12 }}>Are you sure you want to delete this item?</p>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <Button size="small" onClick={close}>
          Cancel
        </Button>

        <Button size="small" onClick={handleDeleteLinked}>
          Delete Linked
        </Button>

        <Button type="danger" size="small" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );

  return (
    <Tooltip title="Delete">
      <Popover
        placement="left"
        trigger="click"
        visible={visible}
        onVisibleChange={setVisible}
        content={content}
      >
        <span style={{ cursor: "pointer" }}>
          <DeleteIcon />
        </span>
      </Popover>
    </Tooltip>
  );
};

export default DeleteActionPopover;
